import React from 'react';
import {Link} from 'react-router-dom';
import {store} from 'base/routes';
import {Businesses} from 'api';
import {connect} from 'react-redux';
import CONFIG from 'base/constants/config';
import {UploadImage} from 'components/UI/Image';
import style from './_BusinessBox.scss';
import { ShowIf } from 'components/utils';

class BusinessBox extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      show: false
    }
  }

  handleDelete(bizID, e) {
    this.props.removeBusiness(bizID);
  }

  accept(bizID, bizDNTID) {
    this.props.accept(bizID, bizDNTID)
  }

  unAccept(bizID) {
    this.props.unAccept(bizID)
  }

  lock(bizID) {
    this.props.unAccept(bizID, 'lock')
  }

  unLock(bizID) {
    this.props.unlock(bizID)
  }

  checkStatus (status) {
    switch (status) {
      case 0:
        return 'Đang chờ duyệt';
      case 2:
        return 'Bị từ chối';
      default:
        return 'Đã duyệt';
    }
  }

  hide() {
    this.setState({
      show: false
    })
  }

  show() {
    this.setState({
      show: true
    })
  }

  render() {
    let Img = null;
    let Data = this.props.data || {};
    if (Data.logo) {
      Img = <UploadImage width={128} height={128} type='BUSINESS' image={Data.logo} transform='crop'/>
    } else {
      Img = <img className="media-object" src={require('assets/images/placeholder-128.jpg')} alt="..." width="128" height="128" alt="logo doanh nghiệp"/>;
    }

    return (
      <div className="business">
        <div className='image-content'>
          {Img}
        </div>
        <div className='info-content'>
          <p className='name'>{Data.name}</p>
          <span className='desc pr10'>
            {Data.address}<br/>
            Số điện thoại: {Data.phone}
          </span>
          <span className='desc'>
            Email: <a href={`mailto:(${Data.email})`}>{Data.email}</a><br/>
            Trạng thái: <b>{this.checkStatus(Data.status)}</b>
          </span>
          <p className='desc'>
            <Link to={`/fair/${this.props.FairId}/business/${Data.id}/products`} className='mr10'><b>Số lượng sản phẩm tham gia: {Data.productsCount || 0}</b></Link>
            <Link to={`/fair/${this.props.FairId}/business/${Data.id}/orders`}><b>Số lượng đơn hàng: {Data.ordersCount || 0}</b></Link>
          </p>
          <ShowIf condition={Data.status === 1}>
            <div>
              <button className='btn btn-danger' onClick={this.lock.bind(this, Data.id)}>Tạm khóa doanh nghiệp</button>
            </div>
          </ShowIf>
          <ShowIf condition={Data.status === 2}>
            <div>
              <button className='btn btn-danger' onClick={this.unLock.bind(this, Data.id)}>Cho phép doanh nghiệp tham gia hội chợ</button>
            </div>
          </ShowIf>
          <ShowIf condition={Data.status === 0}>
            <div className='action-panel'>
              <button className='btn btn-primary' onClick={this.show.bind(this)}>Xem nội dung đăng ký</button>
              <button className='btn btn-primary ml15' onClick={this.accept.bind(this, Data.id, Data.dntId)}>Duyệt</button>
              <button className='btn btn-danger ml15' onClick={this.unAccept.bind(this, Data.id)}>Từ chối</button>
            </div>
          </ShowIf>
          <div className={`popup ${this.state.show ? 'active' : ''}`}>
            <div className='background-overlay'onClick={this.hide.bind(this)} />
            <div className='content-popup'>
              <button className='glyphicon glyphicon-remove' onClick={this.hide.bind(this)} />
              <p><strong>Nội dung tham gia hội chợ:</strong></p>
              <p>{Data.descriptionForFair || ''}</p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(BusinessBox);



// WEBPACK FOOTER //
// ./components/fair/fair-business/BusinessBox.jsx